// Типы для блочной системы навигации

export enum NavigationBlockType {
  ORGANISATION_SIDEBAR = "ORGANISATION_SIDEBAR", // Блок 1: Сайдбар организации (описание + сотрудники + инициативы)
  INITIATIVE_WITH_WORKERS = "INITIATIVE_WITH_WORKERS", // Блок 2: Инициатива + радар сотрудников
  WORKER_WITH_CONNECTIONS = "WORKER_WITH_CONNECTIONS", // Блок 3: Сотрудник + радар связей
}

export interface NavigationBlockState {
  type: NavigationBlockType;
  title: string;
  data?: {
    // Блок 1: Данные организации
    organisationId?: string;
    organisationName?: string;
    currentSector?: string;

    // Блок 2: Данные инициативы
    initiativeId?: string;
    initiativeName?: string;
    initiativeDescription?: string;

    // Блок 3: Данные сотрудника
    workerId?: string;
    workerName?: string;
    workerPosition?: string;
    activeWorkerOrg?: any;

    // Общие данные состояния
    activeSidebarTab?: string;
    dataIds?: any;

    // Состояние радаров
    isOpenOrganisationsRadar?: boolean;
    isOpenWorkerRadar?: boolean;
    isOpenSideBarStackHolders?: boolean;

    // Метаданные для восстановления
    savedFirstStepState?: any;
    savedOrganisationDataIds?: any;
  };
}

export interface NavigationStack {
  blocks: NavigationBlockState[];
  currentIndex: number;
}

// Действия для управления стеком навигации
export interface NavigationActions {
  pushBlock: (block: NavigationBlockState) => void;
  popBlock: () => NavigationBlockState | null;
  getCurrentBlock: () => NavigationBlockState | null;
  canGoBack: () => boolean;
  resetToRoot: () => void;
}
